import { EnvironmentProviders, Provider, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { CoreConstant, Language } from '@libs/vc-core-lib';
import { LocaleService } from 'vcp-common-ui-lib';
import { MergedTranslocoLoader } from './merged-transloco.loader';

function readStoredLanguage(): Language {
    const stored = localStorage.getItem(CoreConstant.VC_LANGUAGE_ABBREVIATION) as Language | null;
    return stored ?? Language.EN;
}

export function provideVcTransloco(): Array<EnvironmentProviders | Provider> {
    const initialLang = readStoredLanguage();

    return [
        provideTransloco({
            config: {
                availableLangs: Object.values(Language),
                defaultLang: initialLang,
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: MergedTranslocoLoader,
        }),
        provideAppInitializer(() => {
            const transloco = inject(TranslocoService);
            const localeService = inject(LocaleService);
            const lang = readStoredLanguage();
            localeService.changeLocale(lang);
            transloco.setActiveLang(lang);
            return transloco.load(lang);
        }),
    ];
}
